import { PropsWithChildren } from 'react';

import { useLoadingStore } from 'store/loadingStore';
import { LoadingKey } from 'utils/promise';

interface LoadingButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loadingKey: LoadingKey;
}

/**
 * Loading Button은 Loading Store(전역상태)를 활용하여 데이터를 로딩중일 때는 disable 처리하도록 한다.
 */
export const LoadingButton = ({ loadingKey, children, ...props }: PropsWithChildren<LoadingButtonProps>) => {
  const { checkIsQuerying } = useLoadingStore();
  const loading = checkIsQuerying(loadingKey);

  return (
    <button {...props} disabled={loading || props.disabled}>
      {children}
    </button>
  );
};
